export const TIME_REPORT_RESUME_TABLE_GET_PRESENCES = "TIME_REPORT_RESUME_TABLE_GET_PRESENCES";
export const TIME_REPORT_RESUME_TABLE_GET_PRESENCES_SUCCESS = "TIME_REPORT_RESUME_TABLE_GET_PRESENCES_SUCCESS";